import type { ITransactionHistoryItem } from 'features/Profile/features/TransactionsMapping/transactionsMapping.api'

export const TRANSACTIONS_HISTORY_COLUMNS = [
  {
    title: 'Patient Name',
    dataIndex: 'patient_name',
    key: 'patient_name',
    render: (_: string, data: ITransactionHistoryItem) => `${data.pat_fname} ${data.pat_lname}`,
    sorter: true,
  },
  {
    title: 'Transaction ID',
    dataIndex: 'transaction_id',
    key: 'transaction_id',
    sorter: true,
  },
  {
    title: 'Phone',
    dataIndex: 'pat_phone',
    key: 'pat_phone',
    sorter: true,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    sorter: true,
  },
  {
    title: 'Created By',
    dataIndex: 'created_by',
    key: 'created_by',
    sorter: true,
  },
  {
    title: 'Created At',
    dataIndex: 'created_at',
    key: 'created_at',
    sorter: true,
  },
]
